var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmotionSadLine = function SvgEmotionSadLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 3a9 9 0 0 1 8.797 10.906l-1.603-1.604a7.2 7.2 0 1 0-3.938 6.12c.344.545.827.987 1.4 1.281A9 9 0 0 1 3 12a9 9 0 0 1 9-9m6.3 10.955 1.273 1.272a1.8 1.8 0 1 1-2.637.1l.091-.1zM12 14.7c1.32 0 2.507.568 3.33 1.473l-.85.774c-.712-.283-1.564-.447-2.48-.447s-1.768.165-2.48.446l-.85-.774A4.49 4.49 0 0 1 12 14.7m-3.15-4.5a1.35 1.35 0 1 1 0 2.7 1.35 1.35 0 0 1 0-2.7m6.3 0a1.35 1.35 0 1 1 0 2.7 1.35 1.35 0 0 1 0-2.7"
  })));
};
export default SvgEmotionSadLine;